/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

import * as Joi from 'joi-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import Form from '../../../../../../common/Form';
import { form as FormStyle } from '../../../../../../style/form';
import { rowSpacing } from '../../../../../../style/variables';
import EventDispatcher from '../../../../../../state/reducers/EventDispatcher';
import ErrorInline from '../../../../../../common/ErrorMessages/ErrorInline';
import { deepObjectExtend } from '../../../../../../utils/object';
import getSiteConfig from '../../../../../../utils/getSiteConfig';
import GiftListCustomerNumberMask from '../../../../../../common/ModalContent/InputMask/GiftListCustomerNumberMask';
import SiteLoader from '../../../../../../../Checkout/containers/Common/SiteLoader/SiteLoader';
import configENV from '../../../../../../config';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => deepObjectExtend(FormStyle(typography, palette), {
    form: {
        marginLeft: '0 !important',
        marginRight: '0 !important',
    },
    buttonWrapper: {
        marginTop: rowSpacing * 2,
        textAlign: 'center',

        '& button': {
            marginRight: '0 !important',
            float: 'none !important',
        },
    },
});

class CustomerNumber extends Form {
    state = {
        data: {
            customerNumber: '',
            zipCode: '',
        },
        isSubmited: false,
        replaceMask: {
            customerNumber: '[\\W]',  // This mask will accept the alphanumeric char on behalf of customer number mask
            zipcode: '*',
        },
        replaceMaskWith: {
            customerNumber: '',
            zipcode: 'toUpperCase',
        },
        consoleErrorValidation: false,
        errors: {},
        origin: '',
    };

    schema = {
        customerNumber: Joi.string()
            .trim()
            .min(9)
            .max(9)
            .required()
            .label('Customer Number'),
        zipCode: Joi.string()
            .trim()
            .min(5)
            .max(5)
            .required()
            .label('Zip Code'),
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        this.setState({ origin: 'customerNumber' }, () => {
            submitData.handleGiftListSubmitLinkUser({
                ...data,
                origin: 'customerNumber',
            });
        });
    };

    render() {
        const {
            classes,
            isReadyState,
            handleGiftListSubmitLinkUser,
            hasBrandSpecific,
        } = this.props;

        const submitData = {
            handleGiftListSubmitLinkUser,
        };
        const isGetSiteConfig = getSiteConfig('phoneNumber')?.props?.children;
        const hasBrandTPF = isGetSiteConfig?.includes('1-800-842-0256');
        const hasBrandCCO = isGetSiteConfig?.includes('1-800-443-8124');

        let placeholder = '01234  5678';
        let adornment = '';
        let adornmentPosition = '';
        let customClass = '';
        let type = 'tel';
        let maskRegEx = [
            /\d/, /\d/, /\d/, /\d/, /\d/, ' ', ' ', /\d/, /\d/, /\d/, /\d/, // this regex will accept only digit
        ];
        if (!hasBrandSpecific) {
            placeholder = '123456789';
            adornment = '';
            adornmentPosition = 'start';
            customClass = 'padding-left: 2px';
            type = 'text';
            maskRegEx = [
                /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, // this regex will accept only digit
            ];
            this.schema = {
                customerNumber: Joi.string()
                    .trim()
                    .min(4)
                    .max(9)
                    .required()
                    .label('Customer Number'),
                zipCode: Joi.string()
                    .trim()
                    .min(5)
                    .max(5)
                    .required()
                    .label('Zip Code'),
            };
        }
        if (hasBrandTPF || hasBrandCCO) {
            placeholder = '123456789';
            adornment = '';
            adornmentPosition = 'start';
            customClass = 'padding-left: 2px';
            type = 'text';
            maskRegEx = [
                /\w/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,     // this regex will accept first input char for TPF rest acceptance will be digit
            ];
            this.schema = {
                customerNumber: Joi.string()
                    .trim()
                    .min(3)
                    .max(10)
                    .required()
                    .label('Customer Number'),
                zipCode: Joi.string()
                    .trim()
                    .min(5)
                    .max(5)
                    .required()
                    .label('Zip Code'),
            };
        }
        return (
            <>
                {(!isReadyState)
                    && (
                        <SiteLoader />
                    )}
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} row margin-top-2x`}
                    disabled={!isReadyState}
                >
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <ErrorInline {...this.props} />
                    <div>
                        {this.renderInput({
                            name: 'customerNumber',
                            label: 'Customer Number *',
                            placeholder,
                            type,
                            pattern: '^[0-9a-zA-z]*$',   // this regex will accept alphanumeric char
                            mask: GiftListCustomerNumberMask,
                            adornment,
                            adornmentPosition,
                            customClass,
                            customProps: { maskRegEx },
                            desktop: true,
                        })}
                    </div>
                    <div>
                        {this.renderInput({
                            name: 'zipCode',
                            label: 'Zip Code *',
                            type: 'tel',
                            pattern: '^[0-9]*$',
                            length: 5,
                            desktop: true,
                        })}
                    </div>
                    <div className={classes.buttonWrapper}>
                        {this.renderButton({
                            label: 'Find By Customer',
                            className: 'findByCustomer',
                            onClick: null,
                            type: 'submit',
                            isValidated: true,
                            isReadyState,
                        })}
                    </div>
                </form>
            </>
        );
    }
}

CustomerNumber.defaultProps = {
    handleGiftListSubmitLinkUser: () => { },
};

CustomerNumber.propTypes = {
    classes: PropTypes.object.isRequired,
    isReadyState: PropTypes.bool.isRequired,
    handleGiftListSubmitLinkUser: PropTypes.func,
    brandID: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const brandID = getSiteConfig('brand-id');
    return {
        isReadyState: newState.isReadyState,
        origin: newState.origin,
        toggleState: newState.toggleState,
        brandID,
        error:
            newState.giftList.error
                && newState.giftList.error.type === 'inline'
                && (newState.origin === 'customerNumber' || newState.giftList.error.name === 'customerNumber')
                ? newState.giftList.error
                : {},
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListSubmitLinkUser: (data) => dispatch(EventDispatcher.handleGiftListSubmitLinkUser(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(CustomerNumber));
